import React, { Suspense, useEffect, useState } from "react";
import Actualite from "./pages/Actualite";
import AdsDetails from "./pages/AdsDetails";
import AdminActualiteAdd from "./pages/admin/AdminActualiteAdd";
import AdminActualiteList from "./pages/admin/AdminActualiteList";
import AdminAvisList from "./pages/admin/AdminAvisList";
import AdminUsers from "./pages/admin/AdminUsers";
import Cart from "./pages/Cart";
import CommandDetails from "./pages/user/CommandDetails";
import CommandList from "./pages/CommandList";
import ContactUs from "./pages/ContactUs";
import DetailProduit from "./pages/DetailProduit";
import Home from "./pages/Home";
import Marketplace from "./pages/Marketplace";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import MesCommandes from "./pages/user/MesCommandes";
import AdminDashboard from "./pages/admin/AdminDashboard";
import AdminActualiteEdit from "./pages/admin/AdminActualiteEdit";
import MessageVerfiMail from "./pages/MessageVerfiMail";
import MyProductList from "./pages/user/MyProductList";
import MyProductDetails from "./pages/user/MyProductDetails";
import EditProductList from "./pages/user/EditProductList";
import DashboardUser from "./pages/DashboardUser";
import Annuaires from "./pages/Annuaires";
import EditProfile from "./pages/user/EditProfile";
import MesVentes from "./pages/user/MesVentes";
import DetailVentes from "./pages/user/DetailVentes";
import Chat from "./pages/user/Chat";
import AdminContact from "./pages/admin/AdminContact";
import AdminDetailContact from "./pages/admin/AdminDetailContact";
import ChangerMotPasse from "./pages/user/ChangerMotPasse";
import EditAnnonce from "./pages/user/EditAnnonce";
import AdminAnnonceList from "./pages/admin/AdminAnnonceList";
import MyDetailsAnnonce from "./pages/user/MyDetailsAnnonce";
import AdminDetailEntreprise from "./pages/admin/AdminDetailEntreprise";
import SignUp2 from "./pages/SignUp2";
import Login2 from "./pages/Login2";
import AddForum from "./pages/AddForum";
import MyAds from "./pages/user/MyAds";
import AddAnnonce from "./pages/user/AddAnnonce";
import Ads from "./pages/Ads";
import AnnuairesList from "./pages/AnnuairesList";
import ProfileEntreprise from "./pages/ProfileEntreprise";
import Promotion from "./pages/Promotion";
import LanguageSelector from "./util/LanguageSelector";
import Loader from "./util/Loader";
import JSLibsLoader from "./util/JSLibsLoader";
import Alerter from "./util/Alerter";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import Header from "./components/Header";
import AddProduct from "./pages/user/AddProduct";
import DashboardHeader from "./components/DashboardHeader";
import NotFound from "./components/NotFound";
import AdminProductsList from "./pages/admin/AdminProductsList";
import Global, { isAdminAccount } from "./util/Global";
import axios from "axios";
import { Currency, DeliveryCountry } from "./components/Utils";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import PaymentResult from "./components/PaymentResult";


const setupAxiosInterceptor = () => {
  axios.interceptors.request.use((config) => {
    const token = localStorage.getItem("token")
    if (token) {
      config.headers["authorization"] = "Bearer " + token
    }
    return config
  }, (error) => {
    return Promise.reject(error)
  })
}

const stripePromise = loadStripe(Global.stripePublicKey)

const DashboardIndexRoute = () => {
  return isAdminAccount() ? <Navigate to="/dashboard/admin" replace /> : <DashboardUser />
}

const App = () => {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    setupAxiosInterceptor()
    setIsLoading(false)
  }, []);

  if (isLoading) {
    return (null)
  }

  return (
    <Suspense fallback={<></>}>
      <BrowserRouter basename={Global.frontend}>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <LanguageSelector>
            <Loader>
              <Alerter>
                <JSLibsLoader />
                <Elements stripe={stripePromise}>
                  <Currency>
                    <DeliveryCountry>
                      <Header>
                        <Routes>
                          <Route index path="/" element={<Home />} exact />
                          <Route path="*" element={<NotFound fullSize={true} />} />

                          <Route path="/login" element={<Login2 />} />
                          <Route path="/messageverifmail" element={<MessageVerfiMail />} />
                          <Route path="/marketplace" element={<Marketplace />} />
                          <Route path="/actualite" element={<Actualite />} />
                          <Route path="/cart" element={<Cart />} />
                          <Route path="/commandList" element={<CommandList />} />
                          <Route path="/contactUs" element={<ContactUs />} />
                          <Route path="/inscription" element={<SignUp2 />} />
                          <Route path="/detailproduit/:id" element={<DetailProduit />} />
                          {/*<Route path="/apropos" element={<Apropos />} /> */}
                          <Route path="/annuaires" element={<AnnuairesList />} />
                          <Route path="/annuaire" element={<Annuaires />} />
                          <Route path="/payment" element={<PaymentResult />} />



                          <Route path="/dashboard" element={<DashboardHeader />}>
                            <Route path="" element={<DashboardIndexRoute />} />
                            <Route path="user/myproducts" element={<MyProductList />} />
                            <Route path="user/myproduct/:id" element={<MyProductDetails />} />
                            <Route path="user/addproduct" element={<AddProduct />} />
                            <Route path="user/editproduct/:id" element={<EditProductList />} />
                            <Route path="user/modifierprofile" element={<EditProfile />} />
                            <Route path="user/mesventes" element={<MesVentes />} />
                            <Route path="user/chat" element={<Chat />} />
                            <Route path="user/detailVentes/:id" element={<DetailVentes />} />
                            <Route path="user/changermotdepasse" element={<ChangerMotPasse />} />
                            <Route path="user/mesannonces" element={<MyAds />} />
                            <Route path="user/monannonce/:id" element={<MyDetailsAnnonce />} />
                            <Route path="user/ajouterannonce" element={<AddAnnonce />} />
                            <Route path="user/modifierannonce/:id" element={<EditAnnonce />} />
                            <Route path="user/mesCommandes" element={<MesCommandes />} />
                            <Route path="user/commandDetails/:id" element={<CommandDetails />} />


                            <Route path="admin" element={<AdminDashboard />} />
                            <Route path="admin/products" element={<AdminProductsList />} />
                            <Route path="admin/orders" element={<MesCommandes isAdmin={true} />} />
                            <Route path="admin/orderDetails/:id" element={<CommandDetails isAdmin={true} />} />
                            <Route path="admin/product/:id" element={<MyProductDetails isAdmin={true} />} />
                            <Route path="admin/editproduct/:id" element={<EditProductList isAdmin={true} />} />
                            <Route path="admin/adminavislist" element={<AdminAvisList />} />
                            <Route path="admin/adminactualityedit/:id" element={<AdminActualiteEdit />} />
                            <Route path="admin/adminactualiteadd" element={<AdminActualiteAdd />} />
                            <Route path="admin/adminactualitelist" element={<AdminActualiteList />} />
                            <Route path="admin/adminannoncedetails/:id" element={<MyDetailsAnnonce isAdmin={true} />} />
                            <Route path="admin/modifierannonce/:id" element={<EditAnnonce isAdmin={true} />} />
                            <Route path="admin/contact" element={<AdminContact />} />
                            <Route path="admin/detailcontact/:id/:passedMessage" element={<AdminDetailContact />} />
                            <Route path="admin/annonces-admin" element={<AdminAnnonceList />} />
                            <Route path="admin/detailentreprise/:id" element={<AdminDetailEntreprise />} />
                            <Route path="admin/adminusers" element={<AdminUsers />} />
                            <Route path="admin/modifierprofile/:id" element={<EditProfile isAdmin={true} />} />
                          </Route>



                          <Route path="/annonces" element={<Ads />} />
                          <Route path="/detailAnnonce/:id" element={<AdsDetails />} />
                          <Route path="/entreprise/:idOrName" element={<ProfileEntreprise />} />
                          <Route path="/addforum" element={<AddForum />} />
                          <Route path="/promotion" element={<Promotion />} />
                        </Routes>
                      </Header>
                    </DeliveryCountry>
                  </Currency>
                </Elements>
              </Alerter>
            </Loader>
          </LanguageSelector>
        </LocalizationProvider>
      </BrowserRouter>
    </Suspense >
  );
};

export default App;
